import { useState } from 'react';
import { adminApi, type AuditEntry } from '../api';
import { useAsync } from '../hooks';
import { Alert, Button, PageHeader, Table, errorText, formatDate } from '../components/ui';

const PAGE = 100;

export default function AuditPage() {
  const first = useAsync(() => adminApi.audit({ limit: PAGE }), []);
  const [more, setMore] = useState<AuditEntry[]>([]);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const entries = [...(first.data ?? []), ...more];
  const loadMore = async () => {
    try {
      const next = await adminApi.audit({ limit: PAGE, before_id: entries[entries.length - 1]?.id });
      setMore([...more, ...next]);
      if (next.length < PAGE) setDone(true);
    } catch (err) {
      setError(errorText(err));
    }
  };

  return (
    <div>
      <PageHeader title="Audit log" />
      {(first.error || error) && <Alert kind="error">{first.error ?? error}</Alert>}
      <Table>
        <thead>
          <tr>
            <th>Time</th>
            <th>User</th>
            <th>Action</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((e) => (
            <tr key={e.id}>
              <td className="whitespace-nowrap text-slate-500">{formatDate(e.ts)}</td>
              <td>{e.username ?? <span className="text-slate-400">system</span>}</td>
              <td className="font-mono text-xs whitespace-nowrap">{e.action}</td>
              <td className="max-w-md truncate font-mono text-xs text-slate-600" title={JSON.stringify(e.details)}>
                {Object.entries(e.details)
                  .map(([k, v]) => `${k}=${typeof v === 'object' ? JSON.stringify(v) : String(v)}`)
                  .join(' ')}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {!done && (first.data?.length ?? 0) >= PAGE && (
        <div className="mt-3 text-center">
          <Button variant="secondary" onClick={loadMore}>
            Load older entries
          </Button>
        </div>
      )}
    </div>
  );
}
